import './utils/tools';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider } from 'react-redux';

// Models:
import { store } from './components/model/store';

// Components:
import Main from './components/main';

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<Route path="/:station?" component={Main} />
		</BrowserRouter>
	</Provider>,
	document.getElementById(store.getState().config.appContainerId)
);



// WEBPACK FOOTER //
// ./src/js/birmingham-meme.js